var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popover',_vm._g(_vm._b({ref:_vm.popoverID,staticClass:"popover",attrs:{"name":_vm.name}},'popover',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }